/* Scroll reveal for the Squares page.
 *
 * Idempotent and re-bindable: the theme editor re-renders a section on
 * every setting change, so this runs again on shopify:section:load and
 * skips elements it has already observed. Anything already in view when
 * the observer attaches is revealed immediately rather than waiting for
 * a scroll that may never come on a short viewport.
 */
(function () {
  var FLAG = 'sqRevealBound';

  function bind(root) {
    var scope = root || document;
    var items = scope.querySelectorAll('.sq-reveal');
    if (!items.length) return;

    if (
      !('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      items.forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.05 }
    );

    items.forEach(function (el) {
      if (el.dataset[FLAG]) return;
      el.dataset[FLAG] = '1';
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bind();
    });
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', function (event) {
    bind(event.target);
  });
})();
